/* 
    this component use for breadcrumps and page title 
*/

import React, { HtmlHTMLAttributes } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Nav } from "react-bootstrap";

interface props extends HtmlHTMLAttributes<HTMLDivElement> {
  title: any;
  breadcrumbs?: any;
}
const Breadcrumbs: React.FC<props> = ({
  children,
  title,
  breadcrumbs,
  ...args
}) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="page-title-box d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-15">
            <h1 className="mb-0 text-xxl">
              {" "}
              {title.split(" ")[0]}{" "}
              <span className="text-accent">
                {title.split(" ").slice(1).join(" ")}
              </span>
            </h1>
            <div className="btn-group">
              <Dropdown>
                {/* Main Dropdown */}
                <Dropdown.Toggle variant="primary" id="dropdown-basic" className="btn btn-primary dropdown-toggle rate_checker">
                  Rate Calculator <i className="mdi mdi-chevron-down"></i>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#action1">
                    Polly Rate Checker
                  </Dropdown.Item>

                  {/* Sub Dropdown */}
                  <Dropdown drop="end">
                    <Dropdown.Toggle as="a" className="dropdown-item" href="#">
                      Lender Price Rate Checker
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item href="#subaction1">275 BPS</Dropdown.Item>
                      <Dropdown.Item href="#subaction2">200 BPS</Dropdown.Item>
                      <Dropdown.Item href="#subaction2">0 BPS</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Dropdown.Menu>
              </Dropdown>

             
            </div>
          </div>

          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {/* <li className="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                                <li className="breadcrumb-item active">My Escalations</li> */}
              {breadcrumbs &&
                Object.keys(breadcrumbs).map((key: any, index: any) => {
                  return (
                    <React.Fragment key={`bedDiv_${index}`}>
                      <li key={`bed-${index}`} className="breadcrumb-item">
                        {breadcrumbs[key] == "#" ? (
                          key
                        ) : (
                          <Link to={breadcrumbs[key]}>{key}</Link>
                        )}
                      </li>
                    </React.Fragment>
                  );
                })}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;
